<div class="tooltip-panel">
  <span class="arrow {{ position() }}"></span>

  @if (tpl()) {
    <ng-container [ngTemplateOutlet]="tpl()" />
  } @else {
    <span [innerHTML]="text() | safe"></span>
  }
</div>
